import * as z from "zod";
const paginationParamModel = z.object({
	offset: z.preprocess((val) => typeof val === "string" ? Number(val) : val, z.number().int().nonnegative().optional()),
	limit: z.preprocess((val) => typeof val === "string" ? Number(val) : val, z.number().int().positive().max(5e3).optional())
});
//#endregion
export { paginationParamModel };
